import { MARQUEE_THEMES } from '../data';

export default function Marquee() {
  return (
    <div
      className="mask-fade-x relative overflow-hidden border-y border-line/10 bg-ink-2 py-5"
      data-testid="theme-marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
            {MARQUEE_THEMES.map((t, i) => (
              <span
                key={i}
                className="flex items-center whitespace-nowrap font-mono text-xs uppercase tracking-[0.28em] text-slate-400 sm:text-sm"
              >
                <span className="px-7 transition-colors hover:text-lime">{t}</span>
                <span className="text-lime">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
